import { addressStagesColorsMap } from '../../../../../../../constants/stagesColorMaps';

export const filterKeys = {
  types: 'types',
  stages: 'stages',
  acceptanceStatuses: 'acceptanceStatuses',
  steps: 'steps',
  sales: 'sales',
};

export const filterPaths = {
  [filterKeys.types]: 'address.typeId',
  [filterKeys.stages]: 'addressLifeCycle.stageAddressLifeCycle.id',
  [filterKeys.acceptanceStatuses]:
    'addressLifeCycle.acceptanceStatusAddressLifeCycle.id',
  [filterKeys.steps]: 'addressLifeCycle.stepAddressLifeCycle.id',
  [filterKeys.sales]: 'addressLifeCycle.saleAddressLifeCycle.id',
};

export const colorMaps = { [filterKeys.stages]: addressStagesColorsMap };
